// https://sandhi.se.com
// https://*.se.com - 1.0
// https://sandhi.se.com
// -------------------------------Base URL ------------------------------------------

export const BaseURL = 'https://sandhi.se.com'
export const fileLink = `${BaseURL}/Upload/`

  
import moment from 'moment'
// ------------Get current Business Unit
export const productUnit = JSON.parse(window.localStorage.getItem('Product'))
// ------------Get current month year
export function GetCurrentDate() {
 var dateFormat = new Date().toLocaleDateString('en-CA')
 return dateFormat
}

export function GetMonthYear() {
    const MonthGet = localStorage.getItem('MonthSet')
  if (MonthGet === 'default') {
      // const date = new Date(2021, 7, 1)
      const date = new Date()
      const month = date.toLocaleString('default', { month: 'long' })
      const year = date.getFullYear()
      const value = `${month}-${year}`
      return value
  }
  else if (MonthGet !== 'default') {
     const date = new Date(MonthGet)
      const month = date.toLocaleString('default', { month: 'long' })
      const year = date.getFullYear()
      const value = `${month}-${year}`
      return value
  }
	// const date = new Date()
}

export const rules = {
  tax: 18, base_Payout_Percentage: 100, incentive_Percentage: 0
}

// -------------Status Value Update
import { CheckCircle, Info } from 'react-feather'
export const productsList = [
    {
      id: 1,
      name: 'Power Products & Industry',
      businessUnit : 'Power Products',
      check: 'Power Products & Industry',
      slugname: 'PPI',
      slug: 'PPI',
      unitName :'PP&I'
    },
    {
      id: 2,
      name: 'Secure Power – HBN',
      businessUnit : 'Secure Power_HBN',
      check: 'Power_HBN',
      slugname: 'HBN',
      slug: 'HBN',
      unitName :'HBN'
    },
    {
      id: 3,
      name: 'Secure Power – Cooling',
      businessUnit : 'Secure Power_Cooling',
      check: 'Cooling',
      slugname: 'Cooling',
      slug: 'Cooling',
      unitName : 'Cooling'
    }
  ]
export const statusObj = {
    0: {color: 'light-secondary', icon: Info, value: 'In Process WO'},
    1: {color: 'light-secondary', icon: Info, value: 'Central Rejected'},
    2: {color: 'light-success', icon: CheckCircle, value: 'Validated WO'},
    3: {color: 'light-success', icon: Info, value: 'CSS Approved'},
    4: {color: 'light-danger', icon: Info, value: 'Discrepancy'},
    5: {color: 'light-info', icon: Info, value: 'Manager Approved'},
    6: {color: 'light-danger', icon: Info, value: 'Manager Rejected Discrepancy'},
    7: {color: 'light-warning', icon: Info, value: 'Manager Approved Discrepancy'},
    8: {color: 'light-warning', icon: Info, value: 'PRF Raised'},
    9: {color: 'light-info', icon: Info, value: 'Manager Approved Invoice PO Awaiting'},
    10: {color: 'light-secondary', icon: Info, value: 'Invoice Raised'},
    11: {color: 'light-info', icon: Info, value: 'Invoice Validated'},
    12: {color: 'light-danger', icon: Info, value: 'Invoice Rejected'},
    13: {color: 'light-warning', icon: Info, value: 'GRN Clarification'},
    14: {color: 'light-info', icon: Info, value: 'GRN Raised'},
    15: {color: 'light-success', icon: Info, value: 'Invoice Paid'},
    16: {color: 'light-dark', icon: Info, value: 'Zero Invoice Value'}

 }
 const CurrentStatus_Post = (value) => {
     if (value === false) {
          const check = 'Completed'
          return check
        }
        else if (value === true) {
           const check = 'Pending'
          return check
        }
        else{
          const check = 'No data'
          return check
        }
   }

export   const getCurrentStatus = (currentStatusItem) => {
  if (currentStatusItem) {
    if (currentStatusItem.csS_Approved_Date === null || currentStatusItem.csS_Approved_Date === undefined) { 
      const check = currentStatusItem.csS_Approved_Date === null 
      let st =  'CSS ' + CurrentStatus_Post(check)
      return st;
    }
    if (currentStatusItem.csS_Mgr_Approved_Date === null || currentStatusItem.csS_Mgr_Approved_Date === undefined) { 
      const check = currentStatusItem.csS_Mgr_Approved_Date === null 
      let st =  'CSS Manager ' +CurrentStatus_Post(check) 
      return st;
    }
   
    if (currentStatusItem.prF_Gen_Date === null || currentStatusItem.prF_Gen_Date === undefined) { 
      const check = currentStatusItem.prF_Gen_Date === null 
      let st ='PRF '+  CurrentStatus_Post(check) 
      return st;
    }
    if (currentStatusItem.invoice_Gen_Date === null || currentStatusItem.invoice_Gen_Date === undefined) { 
      const check = currentStatusItem.invoice_Gen_Date === null 
      let st ='Invoice ' + CurrentStatus_Post(check) 
      return st;
    }
    if (currentStatusItem.fin_Approved_Date === null || currentStatusItem.fin_Approved_Date === undefined) { 
      const check = currentStatusItem.fin_Approved_Date === null 
      let st = 'Finance confirmation ' + CurrentStatus_Post(check) 
      return st;
    }
    if (currentStatusItem.grN_Gen_Date === null || currentStatusItem.grN_Gen_Date === undefined) { 
      const check = currentStatusItem.grN_Gen_Date === null 
      let st = 'GRN '+ CurrentStatus_Post(check) 
      return st;
    }
    if (currentStatusItem.invoice_Paid_Date === null || currentStatusItem.invoice_Paid_Date === undefined) { 
      const check = currentStatusItem.invoice_Paid_Date === null 
      let st = 'Payment '+ CurrentStatus_Post(check) 
      return st;
    }
    return "";
  }
  else{
    return CurrentStatus_Post('No Data')
  }
  
  }
export const reasons = [
      // {value: 1, label: 'Kms Mismatch'},
      {value: 2, label: 'Cost Mismatch – Repeat Case'},
      {value: 3, label: 'Cost Mismatch – Extra payment'},
      {value: 4, label: 'Distance Mismatch'},
      {value: 5, label: 'Amount Mismatch - Additional charges to be paid'},
      {value: 6, label: 'Amount Mismatch - Excess Amount mapped'},
      {value: 7, label: 'Product / Category Mismatch'},
      {value: 9, label: 'Consider for Payout - Not a Repeat Case'},
      {value: 10, label: 'Miscellaneous'},
      {value: 8, label: 'Gas Qty Mismatch'}
]

 export const distanceOptions = [
    {value: 'all', label: 'All'},
    {value: 'ds-a', label: 'DS-A'},
    {value: 'ds-b', label: 'DS-B'},
    {value: 'ds-c', label: 'DS-C'},
    {value: 'ds-d', label: 'DS-D'},
    {value: 'ds-e', label: 'DS-E'}
  ]

export const regionOptions = [
    {value: null, label: 'All', select: 'region' },
    {value: 'North', label: 'North', select: 'region' },
    {value: 'West', label: 'West', select: 'region' },
    {value: 'South', label: 'South', select: 'region' },
    {value: 'East', label: 'East', select: 'region' }
]

export const rolesType = {
  0: { title: "Admin", key: "Admin", roleId: 0 },
  1: { title: "Central", key: "CentralUser", roleId: 1 },
  2: { title: "CSS Manager", key: "CSSManager", roleId: 2 },
  3: { title: "CSS", key: "CSSUser", roleId: 3 },
  4: { title: "Finance", key: "FinanceUser", roleId: 4 },
  5: { title: "SCM", key: "SCMUser", roleId: 5 },
  5: { title: "SuperAdmin", key: "SuperAdmin", roleId: 6 }
}

export const rolesOption = [
  { label: "Admin", value: "Admin", roleId: 0 },
  { label: "Central", value: "CentralUser", roleId: 1 },
  { label: "CSS Manager", value: "CSSManager", roleId: 2 },
  { label: "CSS", value: "CSSUser", roleId: 3 },
  { label: "Finance", value: "FinanceUser", roleId: 4 },
  { label: "SCM", value: "SCMUser", roleId: 5 },
  { label: "SuperAdmin", value: "SuperAdmin", roleId: 6 }
]

export const invoiceOptions  = [
    { value: null, label: 'All'},
    { value: 'Labour', label: 'Labour'},
    { value: 'Supply', label: 'Supply'},
]

export const allStatus = [
  { value: 0, label: 'Central Approved' },
  { value: 3, label: 'CSS Approved' },
  { value: 5, label: 'CSS Manager Approved' },
  { value: 8, label: 'PRF Raised' },
  { value: 9, label: 'PO Waiting' },
  { value: 10, label: 'Invoice Raised' },
  { value: 11, label: 'Invoice Validated' },
  { value: 12, label: 'Invoice Rejected' },
  { value: 13, label: 'GRN Clarification' },
  { value: 14, label: 'GRN Raised' },
  { value: 15, label: 'Invoice Paid' },
  { value: 16, label: 'Zero Value Invoice' },
]

export const workOrderStatus  = [
  { value: 0, label: 'Central Approved'},
  { value: 3, label: 'CSS Approved'},
  { value: 5, label: 'CSS Manager Approved'},
]

export const invoiceStatus = [
  { value: 8, label: 'PRF Raised' },
  { value: 9, label: 'PO Waiting' },
  { value: 10, label: 'Invoice Raised' },
  { value: 11, label: 'Invoice Validated' },
  { value: 12, label: 'Invoice Rejected' },
  { value: 13, label: 'GRN Clarification' },
  { value: 14, label: 'GRN Raised' },
  { value: 15, label: 'Invoice Paid' },
  { value: 16, label: 'Zero Value Invoice' },
]


export const invoiceReversionMap = {
  14: [13, 11, 10, 8, 3, 0],
  13: [11, 10, 8, 3, 0],
  11: [10, 8, 3, 0],
  10: [8, 3, 0],
  9: [3, 0],
  8: [3, 0],
}

export const workOrderReversionMap = {
  3: [0],
  5: [3, 0],
}

export const paymentOptions  = [
    { value: 'All', label: 'All', key:null},
    { value: 'paid', label: 'Paid', key:15 },
    { value: 'notpaid', label: 'Not Paid', key:null }
  ]

 export const reportOptions = [
    {value: 'WorkorderSemiDraft', label: 'Workorder Semi Draft', rules:[1,2,3], api:'GetWorkOrderSemiDraft' },
    {value: 'WorkOrderCount', label: 'WorkOrder Count', rules:[1,2,3], api:'GetWorkOrderCount' },
    {value: 'DiscrepancyReport', label: 'Discrepancy Report', rules:[1,2,3], api:'GetWODiscrepency' },
    {value: 'CssMonthInvoiceReport', label: 'CssMonth Invoice Report', rules:[1,2], api:'GetCSSInvoice' },
    {value: 'NoDueCertificateStatusC', label: 'No-Due Certificate', rules:[1], api:'GetNoDueCertificate' },
    {value: 'FinanceValidationTAT', label: 'Finance Validation TAT', rules:[1,2,4], api:'GetFinanceValidation' }
    // {value: 'NoOfInvoicesSentToCollecto', label: 'No of invoices sent to collecto', rules:[1,2], api:'' }
  ]

  export const DateDifference = (date1, date2) => {
    // Check if either date is null or invalid
   
if (!date1 || isNaN(new Date(date1))) {
      return 0;
    }
  
    // If date2 is null or undefined, set it to today's date
    if (!date2 || isNaN(new Date(date2))) {
      date2 = new Date();
    }
  

    // Calculate the difference in milliseconds
    let differenceInMilliseconds = new Date(date2) - new Date(date1);
  
    // If the difference is negative, set it to 0
    if (differenceInMilliseconds < 0) {
      return 0;
    }
  
    // Convert milliseconds to days
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
  
    // Round down to the nearest whole number
    return Math.floor(differenceInDays);
  };
  
export function formatDate(newDate) {
  return moment(new Date(newDate)).format("DD/MM/YYYY")
}

export function GetPaymentDueDate(startDateStr) {
    const startDate = new Date(startDateStr);
    const dueDate = new Date(startDate.getTime() + 45 * 24 * 60 * 60 * 1000);
    return moment(dueDate).format("DD/MM/YYYY");;
}
  

export function formatDateNew(newDate) {
  return moment(new Date(newDate)).format("YYYY/MM/DD")
}

export function formatDateMonthYear(newDate) {
     const date = new Date(newDate)
      const month = date.toLocaleString('default', { month: 'long' })
      const year = date.getFullYear()
      const value = `${month}-${year}`
      return value
}

const filenameCheck = (array, product, name) => {
   if (product !== null) {
       return `${name}-${product.slug}-${GetMonthYear()}.csv`
  }
  else{
   return `${name}.csv`
  }
}


  const assigned = (item, key) =>{
   let type = typeof item
      if (type === 'undefined' || type === null) {
        return item[key].replace(/[\n\r\t\#\"]/g, '')
      }
      else {
        return item[key]
      }
  }


function convertArrayOfObjectsToCSV(array) {
 let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = Object.keys(array[0]);

  result = '';
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (ctr > 0) result += columnDelimiter;
      result += "\"" + assigned(item, key) + '\"';
      
      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
}

export function downloadCSV(array, product, name) {
  const link = document.createElement('a');
  let csv = convertArrayOfObjectsToCSV(array);
  if (csv == null) return;

  const filename =  filenameCheck(array, product, name)

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename);
  link.click();
}


  // -----------------Allow Export 
   export const exportAllow = (storeGetList, exportData) => {
     if (storeGetList) {
         if (storeGetList.length === 0 || exportData.length === 0) {
           return true
        }
        else {
          return false
        }
     }
  }

 export const customStylesTable = {
    rows: {
        style: {
            minHeight: '68px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '8px', // override the cell padding for head cells
            paddingRight: '8px',
        },
    },
    cells: {
        style: {
            paddingLeft: '8px', // override the cell padding for data cells
            paddingRight: '8px',
        },
    },
}

